/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type BirthNumberLookupResultStatus = (typeof BirthNumberLookupResultStatus)[keyof typeof BirthNumberLookupResultStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BirthNumberLookupResultStatus = {
  not_found: "not_found",
  found: "found",
  not_accessible: "not_accessible",
} as const;
